import { PaymentProvider } from './PaymentProvider';
import { PaymentProviders } from './PaymentProviders';

export class CVUTransferProvider extends PaymentProvider  {
    constructor() {
        super(PaymentProviders.CVUTransfer);
    }
}
